import { render, staticRenderFns } from "./ModalProtocolo.vue?vue&type=template&id=c6f4be76&"
import script from "./ModalProtocolo.vue?vue&type=script&lang=js&"
export * from "./ModalProtocolo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports